<template>
  <div class="contact">

    <div class="header">
      <h1>{{ $t('pages.index.contact.title') }}</h1>
      <p>{{ $t('pages.index.contact.para1') }}</p>
    </div>


    <div class="wrapper">
      <div class="holder">
        <img src="../assets/logos/hidden-field-logo-icon.svg" alt="hiddenfield_logo">
      </div>
      <div class="form">
        <form @submit.prevent="handleSubmit">
          <div class="header"></div>
          <label>{{ $t('pages.index.contact.form.name') }}</label>
          <input
            class="field"
            :class="(submitting && invalidName) ? {'field_error':true} : {'field_okay':true}"
            v-model="contact.name"
            placeholder="Jane Doe"
            @focus="clearStatus"
            @keypress="clearStatus"
          />
          <label>{{ $t('pages.index.contact.form.job') }}</label>
          <input
            class="field"
            :class="(submitting && invalidJob) ? {'field_error':true} : {'field_okay':true}"
            v-model="contact.job"
            placeholder="Developer - Director"
            @focus="clearStatus"
          />
          <label>{{ $t('pages.index.contact.form.company') }}</label>
          <input
            class="field"
            :class="(submitting && invalidCompany) ? {'field_error':true} : {'field_okay':true}"
            v-model="contact.company"
            placeholder="Acme Ltd"
            @focus="clearStatus"
          />
          <label>{{ $t('pages.index.contact.form.email') }}</label>
          <input
            class="field"
            :class="(submitting && invalidEmail) ? {'field_error':true} : {'field_okay':true}"
            v-model="contact.email"
            placeholder="jane.doe@acme.com"
            @focus="clearStatus"
          />
          <div class="form_error_message">
            <span v-if="error" class="error-message">
              {{errorMsg}}
            </span>
            <span v-if="!error && success" class="success-message">
              Thank you. We will be in touch
            </span>
          </div>
          <button class="button">{{ $t('pages.index.contact.form.submit') }}</button>
        </form>
      </div>
    </div>

    <div class="icons_container">
      <div class="icon">
        <a href="https://twitter.com/HiddenFieldLtd">
            <twitter-icon class="svg"></twitter-icon>
        </a>
      </div>
      <div class="icon">
          <a href="https://www.linkedin.com/company/10284998">
              <linkedin-icon class="svg"></linkedin-icon>
          </a>
      </div>
      <div class="icon">
          <a href="tel:+44-1273-917930">
            <phone-icon></phone-icon>
          </a>
      </div>
      <div class="icon">
          <a href="https://github.com/hiddenfield">
            <github-icon></github-icon>
          </a>
      </div>
      <div class="icon">
        <button data-clipboard-text="info@hiddenfield.com">
          <email-icon></email-icon>
        </button>
      </div>
    </div>
    <div class="company_info">
      <p>HiddenField Ltd is a company registered in England and Wales.</p>
      <p>Registered number: 9856723</p>
      <p>Registered office: 7 - 9 The Avenue, Eastbourne, East Sussex, United Kingdom, BN21 3YA</p>
    </div>
    <div class="version">
      v1.0.2020-02-03-a
    </div>
  </div>
</template>

<script>
  export default {
    name: 'contact-form',

    data: function() {
      return {
        submitting: false,
        error: false,
        success: false,
        errorMsg: "",
        contact: {
          name: '',
          job:'',
          company:'',
          email: ''
        },
      }
    },

    methods: {
      handleSubmit() {
        this.submitting = true
        this.clearStatus()
        console.log("Handling Submit");
        if (this.invalidName ||
            this.invalidEmail ||
            this.invalidJob ||
            this.invalidCompany)
        {
          this.error = true;
          this.errorMsg = "Please fill out all the fields";
          return;
        }

        console.error("Entering Adding Contact");
        this.addContact(this)
        console.error("Adding Contact Fire!");
        console.error("We continue");
      },

      submitSuccess() {
        this.success = true;
        this.error = false;
        this.submitting = false;
      },

      submitContactExists() {
        this.error = true;
        this.errorMsg = 'Already Registered';
        this.submitting = false;
      },

      submitFailed() {
        console.error(this.errorMsg);
        this.errorMsg = "Oops! Something went wrong :/";
        this.error = true;
        this.submitting = false;
      },

      submitNetworkError() {
        console.error(this.errorMsg);
        this.errorMsg = "Hmm...network okay?";
        this.error = true;
        this.submitting = false;
      },

      clearStatus() {
        this.success = false;
        this.error = false;
        this.errorMsg = "";
      },

      async addContact(component) {
        await fetch('https://hf-website-go-test-2.appspot.com/contact', {
          method: 'POST',
          body: JSON.stringify(component.contact),
          headers: { 'Content-type': 'application/json; charset=UTF-8' },
        })
        .then(async function(response) {
          if(response.ok) {
            component.submitSuccess();
            return;
          } else {
            const data = await response.json();
            console.log(data);
            if(data.detail === 'Mailchimp email already exists') {
              component.submitContactExists();
            } else {
              console.error(data);
              component.submitFailed();
            }
          }
        })
        .catch(function(error) {
          console.error(error);
          component.submitNetworkError();
        });
      }
    },

    computed: {
      invalidName() {
        return this.contact.name === '';
      },

      invalidEmail() {
        return this.contact.email === '';
      },

      invalidJob() {
        return this.contact.job === '';
      },

      invalidCompany() {
        return this.contact.company === '';
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@/scss/_variables";

  .contact {

    background: $bg-grey;
    min-width: 320px;
    color: white;
    background-image: url('../assets/bkgs/footer-bkg.svg');
    font-family: $title-font;
    background-size: auto 900px;
    background-repeat: no-repeat;
    background-position: top 10px left;
    height: 900px;

    @media screen and (min-width: $tablet-min) and (max-width: $screen-max) {
      background-position: top 230px right -225px;
    }

    @media screen and (min-width: $screen-L-min) {
      background-position: top 230px right -1px;
      margin-top: 100px;
    }

    .header {

      display: none;

      @media screen and (min-width: $screen-L-min) and (max-width: $screen-L-max) {
        display: block;
        float: left;
        width: 28%;
        margin-left: 20%;
        color: black;
      }

      @media screen and (min-width: $screen-XL-min) {
        display: block;
        float: left;
        width: 30%;
        margin-left: 25%;
        color: black;
      }

      p {
        margin-top: 42px;
      }
    }

    .holder {

      background: $white;
      width: 60px;
      height: 60px;
      margin: auto;
      text-align: center;
      transform: rotate(45deg);
      border-radius: 5px;
      margin-top: 20px;
      margin-bottom: -32px;
      box-shadow: -6px -6px 12px 0px rgba(0,0,0,0.1);

      img {
        margin-top: 10px;
        width: 42px;
        height: 42px;
        transform: rotate(-45deg);
      }

    }

    .wrapper {

      @media screen and (min-width: $screen-L-min) {
        float: right;
        margin-right: 20%;
      }
    }

    .form {

      text-align: center;
      width: 370px;
      background: $white;
      margin: auto;
      padding-top: 20px;
      border-radius: 19px;
      box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      padding-bottom: 40px;


      label {
        display: block;
        text-align: left;
        margin: 24px auto 3px 46px;
        font-size: 10px;
        font-weight: 600;
        letter-spacing: 0.5px;
        color: $form-grey;
        text-transform: uppercase;
      }

      .field {
        box-sizing: border-box;
        padding-left: 10px;
        width: 280px;
        height: 45px;
        margin: auto;
        border-radius: 3px;
        border: solid 1px #c1c1c1;
        background-color: #ffffff;
      }

      .field_error {
        border: solid 1px #e2b0b0;
        background-color: #ff000017;
      }

      .field_okay {
        border: solid 1px #c1c1c1;
        background-color: #ffffff;
      }

      .form_error_message {
        height: 50px;
        font-size: 14px;
        line-height: 50px;
      }

      .error-message {
        color: #d33c40;
      }

      .success-message {
        color: #32a95d;
      }

      button {
        cursor: pointer;
        color: $white;
        width: 180px;
        line-height: 42px;
        margin: auto;
        border-radius: 24.5px;
        box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.2);
        background-color: #36c1f1;
        border: none;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }

    .icons_container {
      margin-top: 50px;
      width: 100%;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;

      @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
        width: 50%;
        margin: auto;
        margin-top: 50px;
      }

      @media screen and (min-width: $screen-L-min) and (max-width: $screen-L-max) {
        width: 30%;
        margin: auto 20%;
        margin-top: 465px;
      }

      @media screen and (min-width: $screen-XL-min) {
        width: 30%;
        margin: auto 25%;
        margin-top: 465px;
      }



      button {
        margin: 0;
        padding: 0;
        border: none;
        background: none;
      }

      .icon svg {
        height: 30px;
        width: 30px;
        cursor: pointer;
        fill: $white;
      }

      /* Social media links svg highlighting */
      .icon:hover a svg,
      .icon:hover button svg { fill: $blue; }

      a:hover svg,
      button:hover svg {
        transition: 200ms;
        transition-timing-function: ease-in-out;
        -webkit-transition: 200ms;
        -webkit-transition-timing-function: ease-in-out;
      }
    }

    .company_info {
      margin: 50px 20px 50px 20px;
      color: #cbcbcb;
      text-align: center;
      font-size: 14px;

      @media screen and (min-width: $screen-L-min) {
        padding-top: 50px;
        clear: both;
      }
    }

    .version {
      text-align: center;
      font-size: 10px;
      color: $dark-grey;
    }
  }
</style>
